export const angularJSFactoriesProviders = [
  {
    provide: 'TopToolbarFactory',
    useFactory: ($injector: any) => $injector.get('TopToolbarFactory'),
    deps: ['$injector'],
  },
  {
    provide: '$rootScope',
    useFactory: ($injector: any) => $injector.get('$rootScope'),
    deps: ['$injector'],
  },
  {
    provide: '$state',
    useFactory: ($injector: any) => $injector.get('$state'),
    deps: ['$injector'],
  },
  {
    provide: 'MediasFactory',
    useFactory: ($injector: any) => $injector.get('MediasFactory'),
    deps: ['$injector'],
  },
  {
    provide: '$stateParams',
    useFactory: ($injector: any) => $injector.get('$stateParams'),
    deps: ['$injector'],
  },
  {
    provide: 'PreferencesFactory',
    useFactory: ($injector: any) => $injector.get('PreferencesFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'WhatsappFactory',
    useFactory: ($injector: any) => $injector.get('WhatsappFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'AppFactory',
    useFactory: ($injector: any) => $injector.get('AppFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'TwitterFactory',
    useFactory: ($injector: any) => $injector.get('TwitterFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'LoginFactory',
    useFactory: ($injector: any) => $injector.get('LoginFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'AlertingFactory',
    useFactory: ($injector: any) => $injector.get('AlertingFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'SitesGroupFactory',
    useFactory: ($injector: any) => $injector.get('SitesGroupFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'sites',
    useFactory: ($state: any) => $state.$current.locals.resolve.$$values.sites,
    deps: ['$state'],
  },
  {
    provide: 'siteGroups',
    useFactory: ($state: any) => $state.$current.locals.resolve.$$values.siteGroups,
    deps: ['$state'],
  },
  {
    provide: 'sitesMap',
    useFactory: ($state: any) => $state.$current.locals.resolve.$$values.sitesMap,
    deps: ['$state'],
  },
  {
    provide: 'siteGroupsMap',
    useFactory: ($state: any) => $state.$current.locals.resolve.$$values.siteGroupsMap,
    deps: ['$state'],
  },
  {
    provide: 'PasswordConfirmFactory',
    useFactory: ($injector: any) => $injector.get('PasswordConfirmFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'MessagesFactory',
    useFactory: ($injector: any) => $injector.get('MessagesFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'DropdownItemsFactory',
    useFactory: ($injector: any) => $injector.get('DropdownItemsFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'BusinessHoursFactory',
    useFactory: ($injector: any) => $injector.get('BusinessHoursFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'UsersRolesFactory',
    useFactory: ($injector: any) => $injector.get('UsersRolesFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'PushboxFactory',
    useFactory: ($injector: any) => $injector.get('PushboxFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'MassMessagingFactory',
    useFactory: ($injector: any) => $injector.get('MassMessagingFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'ConfirmationFactory',
    useFactory: ($injector: any) => $injector.get('ConfirmationFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'SiteFilterHelperFactory',
    useFactory: ($injector: any) => $injector.get('SiteFilterHelperFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'AudienceFactory',
    useFactory: ($injector: any) => $injector.get('AudienceFactory'),
    deps: ['$injector'],
  },
  {
    provide: '$mdDialog',
    useFactory: ($injector: any) => $injector.get('$mdDialog'),
    deps: ['$injector'],
  },
  {
    provide: 'StrategiesFactory',
    useFactory: ($injector: any) => $injector.get('StrategiesFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'FavoritesFactory',
    useFactory: ($injector: any) => $injector.get('FavoritesFactory'),
    deps: ['$injector'],
  },
  {
    provide: 'XHRStatsFactory',
    useFactory: ($injector: any) => $injector.get('XHRStatsFactory'),
    deps: ['$injector'],
  },
];
